import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '& > svg': {
      width: '24px',
    },

    '& > p': {
      fontSize: '1.2rem',
    },
  },

  select: {
    width: '260px',

    '& .MuiSelect-root': {
      padding: '0.75rem 1rem',
      fontSize: '1.2rem',
      fontWeight: '600',
      letterSpacing: '0.5px',
    },

    '& fieldset': {
      borderColor: `${theme.palette.secondary.light}`,
    },

    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${theme.palette.secondary.light}`,
    },

    '& .MuiSelect-icon': {
      color: '#1A1C19',
    },

    '& .MuiSelect-selectMenu': {
      backgroundColor: 'transparent',
    },
  },

  paper: {
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: '0px 0px 4px 4px',

    '& ul': {
      padding: '0px',
    },
  },
}))
